import { blackishGrayColor, grayShadeLightColor, lightBrownColor, lightWhiteRedShade, strongRedColor, white } from "../config/ColorObj";

// ---------------------------------------------------------------------------
const promoterDetailsStyles = {
    closeIcon: {
        position: "absolute",
        right: 8,
        top: 8,
    },


    itemCard: {
        backgroundColor: white,
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        marginBottom: 16,
        minHeight: 220,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },

    itemInner: {
        padding: 12,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        height: "100%",
    },


    questionRow: {
        minHeight: 40,
    },

    questionText: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "20px",
    },


    optionCard: {
        padding: "8px 10px",
        marginBottom: 6,
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        backgroundColor: lightWhiteRedShade,
    },

    optionText: {
        fontSize: 13,
    },

    //IMAGE GRID FIX (IMPORTANT)
    imageRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
    },

    imageThumbWrapper: {
        width: "31%",
        height: 200,
        cursor: "pointer",
        borderRadius: 8,
        overflow: "hidden",
        border: "1px solid #eee",
    },

    thumbnail: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
    },

    remarkRow: {
        display: "flex",
        alignItems: "flex-start", // important for multi-line alignment
        gap: 6,
    },

    remarkLabel: {
        fontWeight: 500,
        fontSize: 13,
        whiteSpace: "nowrap",
    },

    remarkValue: {
        fontSize: 13,
        flex: 1,
        whiteSpace: "normal",      // allow wrapping
        wordBreak: "break-word",   // break long words if needed
    },

    // EMPTY
    emptyMsg: {
        textAlign: "center",
        padding: 40,
        color: lightBrownColor,
    },

    headerContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 2,
    },

    headerTitle: {
        fontSize: 16,
        fontWeight: 600,
        color: blackishGrayColor,
    },

    headerSubTitle: {
        fontSize: 13,
        color: grayShadeLightColor,
        fontWeight: 500,
    },

    noteContainer: {
        padding: "0px 15px 4px 15px",
    },

    noteText: {
        color: strongRedColor,
        fontSize: 12,
        fontWeight: 500,
    },
};

export default promoterDetailsStyles;